import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['resetModal', 'disableModal', 'enforceModal', 'cancelEnforcementModal'];

  openResetModal() {
    this.show(this.resetModalTarget);
  }

  openDisableModal() {
    this.show(this.disableModalTarget);
  }

  openEnforceModal() {
    this.show(this.enforceModalTarget);
  }

  openCancelEnforcementModal() {
    this.show(this.cancelEnforcementModalTarget);
  }

  show(modal) {
    this.hideAllModals();
    if (modal) modal.classList.remove("hidden");
  }
  
  hideAllModals() {
    this.resetModalTarget?.classList.add("hidden");
    this.disableModalTarget?.classList.add("hidden");
    this.enforceModalTarget?.classList.add("hidden");
    this.cancelEnforcementModalTarget?.classList.add("hidden");
  }

  closeModal(event) {
    const modal = event.currentTarget.closest('.modal');
    modal?.classList.add('hidden');
  }
}
